import { connect } from 'react-redux';
import { useState, useEffect, useMemo } from 'react';
import {
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { patchDeploymentAction } from '../../redux/actions/deployments';
import { deploymentNameValid } from '../../redux/constants/names';

const RenameDeploymentDialog = ({ open, close, deployment, updateDeployment }) => {
  const [name, setName] = useState(deployment.name);
  // eslint-disable-next-line react-hooks/set-state-in-effect
  useEffect(() => setName(deployment.name), [deployment.name]);
  const validName = useMemo(() => deploymentNameValid(name), [name]);

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Rename Deployment</DialogTitle>
      <DialogContent>
        <TextField
          helperText={
            <>
              Please enter deployment name.
              <br />
              Name must only contains alphanumeric characters, underscore (_), forward slash (/),
              and hyphens (-)
            </>
          }
          label="Name"
          value={name}
          onChange={(event) => setName(event.target.value)}
          fullWidth
        />
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-between' }}>
        <Button variant="contained" onClick={close} color="error">
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={!validName}
          onClick={() => {
            updateDeployment(deployment.site, name);
            close();
          }}
          color="success"
        >
          Rename
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// eslint-disable-next-line no-unused-vars
function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    updateDeployment: (site, newName) => dispatch(patchDeploymentAction(site, newName)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(RenameDeploymentDialog);
